import './App.css';
import { useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import Header from './Pages/Shared/Header';
import Footer from './Pages/Shared/Footer';
import Home from './Pages/Home/Home';
import MySkills from './Pages/Skills/MySkills';
import Contact from './Pages/Contact/Contact';
import Blogs from './Pages/Blogs/Blogs';
import Admin from './Pages/Admin/Admin';
import Login from './Pages/Admin/Login';
import RequireAdmin from './Pages/Admin/RequireAdmin';
import ProjectDetails from './Pages/ProjectDetail/ProjectDetails';
import { ToastContainer, Slide, Zoom, Flip, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AOS from 'aos';
import "aos/dist/aos.css";
import NotFound from './Pages/Shared/NotFound';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1500 });
    AOS.refresh();
  }, []);

  return (
    <div className='bg-[#02162b] min-h-screen absolute top-0 w-full text-white'>
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/skills" element={<MySkills />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
        <Route path="/projects/:id" element={<ProjectDetails />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer></Footer>
      <ToastContainer
        position="top-right"
        autoClose={7000}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        theme="light"
        transition={Slide}
      />
    </div>
  );
}

export default App;
